import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { PortalService } from "../../../services/portal-service.service";
import { AddContract } from "../../../models/contract";
import { LogService } from "../../../services/log.service";

@Component({
  standalone: false,
  selector: "app-add-contracts-tab",
  templateUrl: "./add-contracts-tab.component.html",
  styleUrls: ["./add-contracts-tab.component.scss"],
})
export class AddContractsTabComponent implements OnInit {
  AddContractsForm: UntypedFormGroup;
  success = false;
  error: any = null;
  adding = false;

  constructor(
    private fb: UntypedFormBuilder,
    private portalService: PortalService,
    private logService: LogService,
  ) {}

  ngOnInit() {
    this.AddContractsForm = this.fb.group({
      contractNo: ["", [Validators.required, Validators.maxLength(4), Validators.pattern("^[0-9]+$")]],
      password: ["", [Validators.required]],
      comment: "",
    });
  }

  get f() {
    return this.AddContractsForm.controls;
  }

  addContract() {
    this.resetMessage();
    if (this.adding) {
      return false;
    }
    if (this.AddContractsForm.invalid) {
      return false;
    }
    this.adding = true;
    const request = new AddContract();
    request.contractNo = this.f.contractNo.value;
    request.contractPassword = this.f.password.value;
    if (this.f.comment.value !== "") {
      request.comment = this.f.comment.value;
    }
    return this.portalService.AddContract([request]).subscribe(
      (response) => {
        if (response == null) {
          this.success = true;
          this.adding = false;
          window.location.reload();
          return true;
        }
        this.error = response;
        this.adding = false;
        this.logService.log("Add Contract failed with: ", response);
      },
      (error) => {
        this.error = error;
        this.adding = false;
      },
    );
  }

  resetMessage() {
    this.success = false;
    this.error = null;
  }

  addContractDisabled(): boolean {
    return this.adding || this.AddContractsForm.invalid;
  }
}
